<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Bil Pelbagai">

             <w-flex justify-space-between class="mb4">
                
                <div class="xs4"> 
                    <w-input v-model="cari.tarikh_inbois" required label="Tarikh Bil " type="date"  /> 
                </div>
                <div class="xs4"> 
                    <w-input v-model="cari.tarikh_hingga" required label="Tarikh Hingga " type="date"  /> 
                </div>

                <div class="xs4">
                    <z-lookup label="Nama" name="profil" :url='service_utiliti+"lookup/profil"' :sort="false" :cache="false" v-model="cari.profil_id"  :validators="[validators.required]" /> 
                </div>
                
            </w-flex>
            <w-flex justify-space-between class="mb4">
                 <div class="xs4"> 
                    <w-input v-model="cari.no_inbois" required label="No Bil " /> 
                </div>
                <div class="xs4">
                    <z-lookup label="Status" name="status" :url='service_utiliti+"lookup/lkp_status"' :sort="false" :cache="false" v-model="cari.lkp_inbois_status_id"  :validators="[validators.required]" /> 
                </div>
                <div class="xs4">
                </div>
               
            </w-flex>

              


            
            <div class="mt2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning" :loading="cari.loading">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()" :loading="cari.loading">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>

            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>   

           
            <z-table ref="tbluser" title="Senarai Bil Pelbagai" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
               <!--  <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="add(null)">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template> -->
                <template #item-cell.profil="{ item, label, header, index }">
                    {{item.no_id}} | {{item.profil}} 
                </template>
                 <template #item-cell.no_fail="{ item, label, header, index }">
                    <template v-for="dt, index in item.butiran">
                       <template v-if="dt.no_fail !=null">
                            {{dt.no_fail}},
                        </template>
                        <template v-else>
                            
                        </template>
                    </template>
                </template>
                 <template #item-cell.amaun="{ item, label, header, index }">
                             <div class="text-right">{{$zutil.currency(item.amaun)}}</div> 
                </template>
                
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <template v-if="(item.lkp_inbois_status_id == 1)">
                           <inertia-link :href='$route("inbois.semak",item.id)'>
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-pencil
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                            </inertia-link>
                        </template>
                        <template v-else>
                           <inertia-link :href='$route("inbois.show",item.id)'>
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-file
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                            </inertia-link>
                        </template>
                    </w-flex>
                </template>
            </z-table>
            
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_bil_pelbagai+'inbois',
        reload: true,
        loading: true,
        cari : {
            loading: false,
        },
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Bil Pelbagai', route: '/inbois' },
            { label: 'Senarai', route: '/inbois' }
          ],
           cari : {lkp_inbois_status_id: '', tarikh_inbois:'' , tarikh_hingga:'' ,profil_id:'', no_inbois:''}
        }
         
  },
  methods: {

         search() {
            this.cari.loading = true
             this.$inertia.visit(window.route('inbois.index')+'?lkp_inbois_status_id='+this.cari.lkp_inbois_status_id+'&tarikh_inbois='+this.cari.tarikh_inbois+'&tarikh_hingga='+this.cari.tarikh_hingga+'&profil_id='+this.cari.profil_id+'&no_inbois='+this.cari.no_inbois , {preserveScroll:true})
            
        },
        reset(){
              this.cari = {lkp_inbois_status_id: '', tarikh_inbois:'', tarikh_hingga:'' , profil_id:'', no_inbois:''}
              this.search()
        },
        // load() {
        //     // this.loading = true
        //     this.$zcomm.get(this.service_bil_pelbagai+'inbois'+window.location.search)
        //     .then(res => {
        //       })
        //     .finally(() => {

        //         this.loading = false
        //         });
        // },
  },
  watch: {
    
  },
  mounted() {
    // this.load();
    // override default setting
    this.dialog.width = 900
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>